import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CameraResultType, CameraSource, Plugins} from '@capacitor/core';
import {ActionSheetController, AlertController, LoadingController, ModalController, Platform} from '@ionic/angular';
import {IneService} from '../../services/ine.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import {IOCR} from '../../interfaces/ocr';
import {BidService} from '../../services/bid.service';
import {DocumentScanPage} from '../document-scan/document-scan.page';
import {AlertService} from '../../services/alert.service';

declare var IcarSDK: any;

const FormData = require('form-data');

const {Camera} = Plugins;

@Component({
  selector: 'app-ine',
  templateUrl: './ine.page.html',
  styleUrls: ['./ine.page.scss'],
})
export class InePage implements OnInit {

  images: any[] = [];
  imageIneFrente: any = {};
  imageIneAtras: any = {};
  @ViewChild('fileInput', {static: false}) fileInput: ElementRef;

  type: string;
  messageButtonFront = '';
  messageButtonBack = '';

  operationId;
  selfieBase64;
  firmaBase64;
  cargoImagenDelatera: boolean;
  cargoImagenTrasera: boolean;
  faceRatio: number;

  constructor(private plt: Platform,
              private actionSheetCtrl: ActionSheetController,
              public alertController: AlertController,
              private ineService: IneService,
              private bidiService: BidService,
              private router: Router,
              private storageService: StorageService,
              private loadingController: LoadingController,
              private route: ActivatedRoute,
              private modalCtr: ModalController,
              private alertService: AlertService) {
    this.imageIneFrente = {};
    this.imageIneAtras = {};
    this.cargoImagenDelatera = false;
    this.cargoImagenTrasera = false;

  }


  ngOnInit() {

    this.imageIneFrente = {};
    this.imageIneAtras = {};
    this.cargoImagenDelatera = false;
    this.cargoImagenTrasera = false;

    this.storageService.getStorage('faceRatio').then((f: any) => {
      this.faceRatio = Number(f.value);
    });
    this.storageService.getStorage('operationID').then((op: any) => {

      this.operationId = op.value;
      this.uploadSefie();
    });

    this.type = this.route.snapshot.paramMap.get('type');

    this.storageService.saveToStorage('docType', this.type);
    switch (this.type) {
      case 'Identificación INE':
        this.messageButtonFront = 'Capturar INE Anverso';
        this.messageButtonBack = 'Capturar INE Reverso';
        break;

      case 'Cedula Profesional':
        this.messageButtonFront = 'Cedula Profesional Anverso';
        this.messageButtonBack = 'Cedula Profesional Reverso';
        break;
      case 'Pasaporte Mexicano':
        this.messageButtonFront = 'Captura Pasaporte';
        break;

      case 'Forma Migratoria':
        this.messageButtonFront = 'Capturar FM Anverso';
        this.messageButtonBack = 'Capturar FM Reverso';
        break;
    }


  }

  async getValuesStorge() {


    this.faceRatio = Number(await this.storageService.getStorageSync('faceRatio'));
    console.log(this.faceRatio);

  }

  async selectImageSource(typeIne) {
    const buttons = [
      {
        text: 'Tomar una foto',
        icon: 'camera',
        handler: () => {
          this.addImage(CameraSource.Camera, typeIne);
        }
      }
    ];

    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccionar',
      buttons
    });
    await actionSheet.present();
  }

  async addImage(source: CameraSource, typeIne: string) {
    const image = await Camera.getPhoto({
      webUseInput: true,
      quality: 10,
      correctOrientation: true,
      resultType: CameraResultType.Base64,
      source
    });


    if (typeIne === 'ineAdelante') {
      this.imageIneFrente = {
        _id: '1',
        name: 'imageName',
        createdAt: new Date(),
        base64: `${image.base64String}`,
        url: `data:image/${image.format};base64,${image.base64String}`,
        blob: ''
      };

      const rawData = atob(this.imageIneFrente.base64);
      const bytes = new Array(rawData.length);
      for (let x = 0; x < rawData.length; x++) {
        bytes[x] = rawData.charCodeAt(x);
      }

      console.log(`image/${image.format}`);
      const arr = new Uint8Array(bytes);
      const blob = new Blob([arr], {type: `image/${image.format}`});
      this.imageIneFrente.blob = blob;

      this.uploadFileImage(this.imageIneFrente.blob, 'ANVERSO');
    } else {
      this.imageIneAtras = {
        _id: '1',
        name: 'imageName',
        createdAt: new Date(),
        base64: `${image.base64String}`,
        url: `data:image/${image.format};base64,${image.base64String}`,
        blob: ''
      };
      const rawData = atob(this.imageIneAtras.base64);
      const bytes = new Array(rawData.length);
      for (let x = 0; x < rawData.length; x++) {
        bytes[x] = rawData.charCodeAt(x);
      }

      console.log(`image/${image.format}`);
      const arr = new Uint8Array(bytes);
      const blob = new Blob([arr], {type: `image/${image.format}`});
      this.imageIneFrente.blob = blob;

      this.uploadFileImage(this.imageIneFrente.blob, 'REVERSO');
    }
  }

  deleteImage(index) {
    if (index === 'imageIneFrente') {
      this.imageIneFrente = {};

    } else {
      this.imageIneAtras = {};
    }

  }

  async ineOcr() {


    this.storageService.removeValueInStorage('OCR').then();
    let req: IOCR;
    let reqOperation;
    switch (this.type) {
      case 'Identificación INE':

        reqOperation = {
          currentSecuenceId: '6',
          activityValue: 'ID_INE_CAPTURED'
        };
        req = {
          operationId: this.operationId,
          data: {
            b64BackIdImg: '',
            b64FrontIdImg: '',
            b64Selfie: ''
          }
        };

        break;

      case 'Cedula Profesional':
        reqOperation = {
          currentSecuenceId: '6',
          activityValue: 'ID_OTHER_CAPTURED'
        };
        req = {
          operationId: this.operationId,
          data: {
            b64BackIdImg: '',
            b64FrontIdImg: '',
            b64Selfie: ''
          }
        };

        break;
      case 'Pasaporte Mexicano':
        reqOperation = {
          currentSecuenceId: '6',
          activityValue: 'ID_OTHER_CAPTURED'
        };
        req = {
          operationId: this.operationId,
          data: {
            b64BackIdImg: '',
            b64FrontIdImg: '',
            b64Selfie: ''
          }
        };

        break;

      case 'Forma Migratoria':
        reqOperation = {
          currentSecuenceId: '6',
          activityValue: 'ID_OTHER_CAPTURED'
        };
        req = {
          operationId: this.operationId,
          data: {
            b64BackIdImg: '',
            b64FrontIdImg: '',
            b64Selfie: ''
          }
        };
        break;
    }


    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });

    let docIdAnverso;
    let docIdReverso;
    let docIdSelfie;
    this.storageService.getStorage('documentIdSelfie').then(selfie => {

      docIdSelfie = selfie.value;
      this.storageService.getStorage('documentIdANVERSO').then(storage => {

        console.log(storage);
        docIdAnverso = storage.value;
        this.storageService.getStorage('documentIdREVERSO').then(st => {

          docIdReverso = st.value;

          if (this.type === 'Pasaporte Mexicano') {
            req.data.b64FrontIdImg = docIdAnverso;
            req.data.b64BackIdImg = docIdAnverso;
            req.data.b64Selfie = docIdSelfie;
          } else {
            req.data.b64FrontIdImg = docIdAnverso;
            req.data.b64BackIdImg = docIdReverso;
            req.data.b64Selfie = docIdSelfie;
          }


          this.bidiService.Ocr(req).subscribe(async (data: any) => {


            if (data.status === 'complete') {

              this.bidiService.updateOperation(this.operationId, reqOperation).subscribe();

              this.storageService.saveToStorage('TEST_FACE_RECOGNITION_RATIO', data.validationDocument.TEST_FACE_RECOGNITION_RATIO);

              let faceRecognition = 0;
              try {
                faceRecognition = Number(data.validationDocument.TEST_FACE_RECOGNITION_RATIO);
                console.log('vfaceRecognitionfaceRecognitionfaceRecognition');
                if (isNaN(faceRecognition)) {
                  faceRecognition = 0;
                }
              } catch (e) {
                faceRecognition = 0;
                console.error(e);
              }

              console.log(faceRecognition + '>=' + this.faceRatio);
              if (faceRecognition >= this.faceRatio) {
                //  if (true) {
                this.storageService.saveToStorage('OCR', JSON.stringify(data.normalDocument)).then();
                const alert = await this.alertController.create({
                  cssClass: 'ios',
                  mode: 'ios',
                  header: 'Exito',
                  message: 'Documento identificado con exito',
                  buttons: ['Aceptar']
                });

                await alert.present();
                this.loadingController.dismiss();
                // this.storageService.saveToStorage('INEADELANTE', this.imageIneFrente.base64).then();
                // this.storageService.saveToStorage('INEATRAS', this.imageIneAtras.base64).then();
                this.nextPage();
              } else {
                this.loadingController.dismiss();
                const aviso = await this.alertService.presentAlertConfirm('Aviso', 'Es necesario volver a capturar el rostro  ¿Deseas regresar a la captura facial?');
                if (aviso) {
                  this.storageService.removeValueInStorage('OCR').then();
                  this.router.navigateByUrl('dashboard/face').then();

                }
              }

            } else {
              const alert = await this.alertController.create({
                cssClass: 'ios',
                mode: 'ios',
                header: '',
                message: 'No se pudo realizar la extracción correctamente, capture nuevamente',
                buttons: ['Aceptar']
              });

              await alert.present();

              this.loadingController.dismiss();
            }
          }, async (error) => {
            const alert = await this.alertController.create({
              cssClass: 'ios',
              mode: 'ios',
              header: 'Error',
              message: 'No se pudo realizar la extracción correctamente, capture nuevamente',
              buttons: ['Aceptar']
            });
            await alert.present();
            this.loadingController.dismiss();

          });

        });
      });

    });
  }


  nextPage() {

    switch (this.type) {
      case 'Identificación INE':
        this.router.navigateByUrl('ine-data').then();

        break;

      case 'Cedula Profesional':
        this.router.navigateByUrl('cedula-profesional').then();

        break;
      case 'Pasaporte Mexicano':
        this.router.navigateByUrl('pasaporte').then();

        break;

      case 'Forma Migratoria':
        this.router.navigateByUrl('forma-migratoria').then();
        break;
    }
  }

  async uploadFileImage(blob, type) {
    let code;
    switch (this.type) {
      case 'Identificación INE':
        if (type === 'ANVERSO') {
          code = 'IDOFA';
        } else {
          code = 'IDOFB';
        }
        break;

      case 'Cedula Profesional':
        if (type === 'ANVERSO') {
          code = 'IDCEDPA';
        } else {
          code = 'IDCEDPB';
        }

        break;
      case 'Pasaporte Mexicano':
        if (type === 'ANVERSO') {
          code = 'PASSPORT';
        }

        break;

      case 'Forma Migratoria':
        if (type === 'ANVERSO') {
          code = 'FM3ANVERSO';
        } else {
          code = 'FM3REVERSO';
        }
        break;
      case 'Selfie':
        code = 'RF';
        break;
    }
    const form = new FormData();
    const file = this.blobToFile(blob, 'my-image.jpeg');

    form.append('document', file);
    form.append('operationId', this.operationId);
    form.append('contentType', 'image/jpeg');
    form.append('documentCode', code);
    form.append('extension', 'jpeg');
    form.append('folderDescripcion', this.type + type);
    form.append('folderPath', '1');
    form.append('folderTitle', code);
    form.append('name', 'RFACIAL');


    this.bidiService.uploadFile(form).subscribe((data: any) => {

      if (type === 'ANVERSO') {
        this.cargoImagenDelatera = true;
      }

      if (type === 'REVERSO') {
        this.cargoImagenTrasera = true;
      }
      this.loadingController.dismiss().then();
      this.storageService.saveToStorage('documentId' + type, data.id);
    }, error => {

      this.loadingController.dismiss().then();
    });


  }

  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }

  async takeDocument(val) {
    console.log(val);
    const modal = await this.modalCtr.create({
      component: DocumentScanPage
    });

    modal.onWillDismiss()
      .then((data) => {
      });


    await modal.present();
  }


  uploadSefie() {
    this.storageService.getStorage('FACEBASE64').then(data => {
      this.selfieBase64 = data.value;

      console.log(this.selfieBase64);

      if (this.selfieBase64 !== null) {

        const rawData = atob(data.value);
        const bytes = new Array(rawData.length);
        for (let x = 0; x < rawData.length; x++) {
          bytes[x] = rawData.charCodeAt(x);
        }

        const arr = new Uint8Array(bytes);
        const blob = new Blob([arr], {type: `image/jpg`});

        const form = new FormData();
        const file = this.blobToFile(blob, 'my-image.jpg');

        form.append('document', file);
        form.append('operationId', this.operationId);
        form.append('contentType', 'image/jpg');
        form.append('documentCode', 'RF');
        form.append('extension', 'jpg');
        form.append('folderDescripcion', 'Selfie');
        form.append('folderPath', '1');
        form.append('folderTitle', 'RF');
        form.append('name', 'RFACIAL');


        this.bidiService.uploadFile(form).subscribe((dataUp: any) => {

          this.storageService.saveToStorage('documentIdSelfie', dataUp.id);
        }, error => {

        });
      }
    });
  }


}
